<template>
    <VJoyPanel class="main-component" padding="large">
        <template #panel-title>
            <slot name="title" />
        </template>
        <template v-if="slots['subtitle']" #panel-subtitle>
            <slot name="subtitle" />
        </template>
        <template #panel-title-action>
            <slot name="title-action" />
        </template>

        <template #panel-body>
            <slot name="content" />
        </template>
    </VJoyPanel>
</template>

<script setup lang="ts">
    import {useSlots} from 'vue';
    import {VJoyPanel} from '@maltjoy/core-vue';

    const slots = useSlots();
</script>
<style lang="scss">
    .main-component {
        scroll-margin-top: calc(var(--header-menu-height) + var(--joy-core-spacing-2));

        .joy-panel__header-title {
            min-width: 200px;
        }
    }
</style>
